<template>
  <div class="row">
    <div class="col-lg-4">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Brand</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Brand Background color</td>
          <td>
            <input type="color" v-model="brand.brandColor">
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Upload Logos</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Brand logo</td>
            <td>
              <div v-if="brand.logo.url" class="logo-preview">
                <img :src="brand.logo.url" alt="Brand Logo Preview" width="100">
              </div>
            </td>
          <td>
            <input type="file" name="" accept="image/*" id="fileUpload">
            <button class="m-t-md btn btn-sm btn-success" @click="uploadImage">Upload logo</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-4">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Contact Person</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Name</td>
          <td>
            <div class="input-group">
                <input type="text" name="" id="" class="form-control" v-model="brand.contact.name">
            </div>
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>
            <div class="input-group">
                <input type="email" name="" id="" class="form-control" v-model="brand.contact.email">
            </div>
          </td>
        </tr>
        <tr>
          <td>Skype</td>
          <td>
            <div class="input-group">
                <input type="text" name="" id="" class="form-control" v-model="brand.contact.skype">
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <button type="button" class="btn float-right btn-primary" @click="saveChanges()">Save</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { String } from '../../../../../mixins/helperMixin'
import axios from 'axios'
import { BRAND_SET } from '../../../../../store/mutation-types'
import EditText from '../../../../Helpers/Form/EditText'

export default {
  components: {
    eTxt: EditText
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand'
    })
  },

  mixins: [String],
  methods: {
    async saveChanges () {
      try {
        let resp = await axios.patch(`/advertisers/brands/${this.brand.id}`, {
          'contact.name': this.brand.contact.name,
          'contact.email': this.brand.contact.email,
          'contact.skype': this.brand.contact.skype,
          'brandColor': this.brand.brandColor
        })
        this.$store.commit(BRAND_SET, resp.data)
        this.$toastr.success('Updated details', 'Yasss!')
      } catch (error) {
        this.$toastr.error(error, 'Not again...')
      }
    },
    async uploadImage () {
      try {
        let formData = new FormData()
        let file = document.querySelector('#fileUpload')
        formData.append('file', file.files[0])
        let resp = await axios.post(`advertisers/brands/${this.brand.id}/logo`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.$toastr.success('File Uploaded', 'Yasss!')
        this.$store.commit(BRAND_SET, resp.data)
      } catch (error) {
        this.$toastr.error(error, 'QQ')
      }
    }
  }
}
</script>
<style>
.input-group-append {
  display: flex;
}
.float-right {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand/Tabs/General.vue